<div [style.display]="showCreate ? 'none' : ''">
    <app-card [showHeader]="false">
        <!-- <app-page-tools [service]="headerServiceInstance"></app-page-tools> -->
        <app-base-page-tools [service]="headerServiceInstance" [fieldsConfigService]="fieldsConfigService" [canCreate]="canCreate"/>
        <!-- <app-base-page-tools [service]="headerServiceInstance" [fieldsConfigService]="fieldsConfigService" [canCreate]="canCreate"/> -->

        <div class="p-b-15">
            <app-base-criteria>
                <ng-content select="[criteria]"></ng-content>
            </app-base-criteria>
        </div>
        @if(permissions?.access) {
        <app-base-grid [service]="headerServiceInstance" [fieldsConfigService]="fieldsConfigService"  [canEdit]="canEdit"
            [canDelete]="canDelete"/>
        }
    </app-card>
</div>


<div [style.display]="showCreate ? '' : 'none'">
    <app-base-create [fieldsConfigService]="fieldsConfigService" [canCreate]="canCreate"
  [canEdit]="canEdit">
        <ng-content select="[form]"></ng-content>
    </app-base-create>
</div>
